var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"block mx-auto max-w-3xl border-l-2 py-2 pl-4 mt-4"},[_c('q',{staticClass:"font-serif text-2xl sm:text-4xl"},[_vm._v(_vm._s(_vm.text))]),_c('p',{staticClass:"mt-4 italic"},[_vm._v(_vm._s(_vm.author))])])}
var staticRenderFns = []

export { render, staticRenderFns }